import { render, staticRenderFns } from "./QcqQualityStarsSelector.vue?vue&type=template&id=24059468&scoped=true&lang=pug&"
import script from "./QcqQualityStarsSelector.vue?vue&type=script&lang=ts&"
export * from "./QcqQualityStarsSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24059468",
  null
  
)

export default component.exports